import { createApi } from "@reduxjs/toolkit/query/react";
import * as config from "config";
import * as utils from "utils";

const baseQuery = async (args, api, extraOptions) => {
  try {
    const response = await utils.authenticatedFetch(
      config.endpoints.email(args.url),
      args.payload || {}
    );
    return {
      data: await response.json(),
    };
  } catch (e) {
    return {
      error: String(e),
    };
  }
};

export const emailServiceApi = createApi({
  reducerPath: "emailServiceApi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    sendPeerReviewEmail: builder.mutation({
      query: ({ senderName, emailTo, submissionUrl, submissionName }) => ({
        url: "send-peer-review-email",
        payload: {
          body: JSON.stringify({
            senderName,
            emailTo,
            submissionUrl,
            submissionName,
          }),
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
        },
      }),
    }),
  }),
});

export const { useSendPeerReviewEmailMutation } = emailServiceApi;
